import { useContext, useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import BIContainer from "@/components/ui/bi/BIContainer";
import CategorySummaryContainer from "@/components/ui/CategorySummaryContainer";
import TitleBar from "@/components/ui/TitleBar";
import { routes } from "@/configs/router.config/routes";
import { AppContext } from "@/contexts/AppContext";
import { useDisplayGroups } from "@/hooks/useDisplayGroups";
import { useVocCountData } from "@/hooks/useVocCountData";
import { useWorkspaceRedirect } from "@/hooks/useWorkspaceRedirect";

export const AnalysisPage: React.FC = () => {
  const { isComparisionMode } = useContext(AppContext);
  const location = useLocation();
  const categorySummaryRef = useRef<HTMLDivElement>(null);

  const { id } = useParams<{ id: string; }>();
  const { filterByPaths } = useVocCountData();
  const { getDisplayGroup } = useDisplayGroups();
  const displayGroup = id ? getDisplayGroup(id) : undefined;

  // ワークスペース切り替え時にホームページにリダイレクト
  useWorkspaceRedirect((workspaceId) => routes.top(workspaceId));

  // ページヘッダー部のタイトル
  const pageTitle = displayGroup?.name ?? "";

  const renderBI = () => {
    if (!displayGroup) return;

    const vocCountData = filterByPaths(displayGroup.categoryPaths);

    return vocCountData && (
      <div className="px-5 pt-5 max-w-[1380px]">
        <BIContainer
          displayGroup={displayGroup}
          vocCountData={vocCountData}
          hideDataVisibilityToggle={false}
        />
      </div>
    );
  };

  const scrollToSummary = () => {
    if (!categorySummaryRef.current) return;

    const elementPos = categorySummaryRef.current.getBoundingClientRect().top;
    window.scrollTo({ top: elementPos + scrollY - 90, behavior: "smooth" });
  };

  // テーブル内の分析ボタン押下時にサマリの位置までスクロール
  useEffect(() => {
    setTimeout(() => {
      scrollToSummary();
    }, 100);
  }, [location]);

  // 比較モード時にサマリの位置までスクロール
  useEffect(() => {
    setTimeout(() => {
      if (!isComparisionMode) return;
      scrollToSummary();
    }, 100);
  }, [isComparisionMode]);

  return (
    <div className="flex flex-col w-full flex-1">
      <TitleBar title={pageTitle} />

      <div className="flex flex-col flex-1">
        {renderBI()}

        {displayGroup && (
          <div className="flex flex-1 max-w-[1380px]" ref={categorySummaryRef}>
            <CategorySummaryContainer displayGroup={displayGroup} isComparisionMode={isComparisionMode} />
          </div>
        )}
      </div>
    </div>
  );
};

export default AnalysisPage;
